import { PlausibleEventOptions, track } from '@plausible-analytics/tracker';

function promisifiedTrack(
  eventName: string,
  options?: PlausibleEventOptions
): void {
  return track(eventName, { ...options });

  // return new Promise<any>((res, rej) => {
  //   track(eventName, {
  //     ...options,
  //     callback(result) {
  //       if (result === undefined) {
  //         res(result);
  //         return;
  //       }

  //       if ('error' in result) {
  //         rej(result.error)
  //         return;
  //       }

  //       res(result);
  //     },
  //   })
  // })
}

export function useAnalytics() {
  return { track: promisifiedTrack };
}
